<template>
  <div class="contact-us-page">
    <div class="hero-section">
      <h1 class="hero-title">Contact us</h1>
      <p class="hero-subtitle">
        Stay connected with PERKI. Whether through our office, phone, or email, we are here to
        foster collaboration, answer inquiries, and strengthen our shared commitment to
        cardiovascular health.
      </p>
    </div>

    <div class="contact-grid">
      <div class="contact-column">
        <h2 class="column-title">InaHeart Secretariat</h2>
        <div class="contact-item">
          <img :src="phoneIcon" alt="Phone" class="contact-icon" />
          <div class="contact-details">
            <p>+62 811 811 568 (WA Only)</p>
            <p>+62 21 568 1149 ext 101</p>
          </div>
        </div>
        <div class="contact-item">
          <img :src="emailIcon" alt="Email" class="contact-icon" />
          <div class="contact-details">
            <p>secretariat@inaheart.org</p>
          </div>
        </div>
      </div>

      <div class="contact-column">
        <h2 class="column-title">Collegium InaHeart Secretariat</h2>
        <div class="contact-item">
          <img :src="phoneIcon" alt="Phone" class="contact-icon" />
          <div class="contact-details">
            <p>+62 21 568 1149 ext 106</p>
          </div>
        </div>
        <div class="contact-item">
          <img :src="emailIcon" alt="Email" class="contact-icon" />
          <div class="contact-details">
            <p>collegium@inaheart.org</p>
          </div>
        </div>
      </div>

      <div class="contact-column">
        <h2 class="column-title">InaHeart Web Support</h2>
        <div class="contact-item">
          <img :src="phoneIcon" alt="Phone" class="contact-icon" />
          <div class="contact-details">
            <p>+62 878 7578 9611 (WA Only)</p>
            <p>+62 21 568 1149 ext 101</p>
          </div>
        </div>
      </div>
    </div>

    <div class="location-section">
      <div class="location-header">
        <p class="location-subtitle">Location</p>
        <h2 class="location-title">Find Us</h2>
        <p class="location-description">
          Find PERKI's headquarters and connect with us for collaboration or further information.
        </p>
      </div>

      <div id="leaflet-map-container" style="height: 450px; width: 100%; border-radius: 8px"></div>
    </div>
  </div>
</template>

<script>
// --- DIUBAH: Import Leaflet ---
import L from 'leaflet'
// Import CSS wajib untuk Leaflet
import 'leaflet/dist/leaflet.css'

// Import icon untuk card (tetap sama)
import phoneIcon from '@/assets/img/about-us/contact-us/phone-contact.png' // Ganti path ini
import emailIcon from '@/assets/img/about-us/contact-us/email-contact.png' // Ganti path ini

// --- [PENTING] PERBAIKAN ICON MARKER LEAFLET ---
// Ini adalah perbaikan umum agar icon marker bawaan Leaflet
// dapat tampil dengan benar di proyek (seperti Vue/React)
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
})
// --- Akhir Perbaikan Icon ---

export default {
  name: 'ContactUs',
  data() {
    return {
      phoneIcon,
      emailIcon,
      map: null, // Untuk menyimpan instance peta Leaflet
    }
  },
  mounted() {
    // Koordinat dari Anda
    const lat = -6.209863403198918
    const long = 106.81242518717383
    const zoom = 20

    try {
      // 1. Inisialisasi Peta
      //    Panggil L.map() dan set 'leaflet-map-container' sebagai target
      this.map = L.map('leaflet-map-container').setView([lat, long], zoom)

      // 2. Tambahkan Tile Layer (Gambar peta)
      //    Kita gunakan OpenStreetMap yang gratis
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.map)

      // 3. Tambahkan Marker (Pin)
      L.marker([lat, long])
        .addTo(this.map)
        .bindPopup('PERKI Headquarters') // Teks saat pin di-klik
    } catch (error) {
      console.error('Failed to initialize Leaflet map:', error)
      const mapElement = document.getElementById('leaflet-map-container')
      if (mapElement) {
        mapElement.innerHTML = 'Error loading map.'
      }
    }
  },
  // Hapus map saat komponen dihancurkan (best practice)
  beforeUnmount() {
    if (this.map) {
      this.map.remove()
    }
  },
}
</script>

<style scoped>
/* Semua style .hero-section, .contact-grid, dll, tetap sama */
.contact-us-page {
  font-family: 'Arial', sans-serif;
  color: #333;
  background-color: #fff;
}

/* Section 1: Hero */
.hero-section {
  text-align: center;
  padding: 4rem 2rem 3rem 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  font-size: 3rem;
  font-weight: 700;
  color: #000;
  margin-bottom: 1.5rem;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.7;
}

/* Section 2: Contact Grid */
.contact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto 5rem auto;
  padding: 0 2rem;
}

.contact-column {
  background-color: #f8f9fa;
  padding: 2rem;
  border-radius: 8px;
}

.column-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #e10f28; /* Warna merah PERKI */
  margin-bottom: 2rem;
  text-align: center;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.contact-icon {
  width: 24px;
  height: 24px;
  margin-right: 1rem;
  margin-top: 4px;
  object-fit: contain;
}

.contact-details p {
  margin: 0;
  font-size: 1rem;
  color: #555;
  line-height: 1.6;
}

/* Section 3: Location & Map */
.location-section {
  max-width: 1200px;
  margin: 0 auto 5rem auto;
  padding: 0 2rem;
}

.location-header {
  margin-bottom: 2rem;
}

.location-subtitle {
  font-size: 1rem;
  font-weight: 600;
  color: #666;
  margin: 0;
}

.location-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #000;
  margin-bottom: 1rem;
}

.location-description {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.7;
  max-width: 800px;
}

/* DIUBAH: Pastikan container map memiliki style yang benar */
#leaflet-map-container {
  height: 450px;
  width: 100%;
  border-radius: 8px;
  z-index: 1; /* Kadang diperlukan agar map tampil di atas elemen lain */
}

/* --- Responsive (Tetap sama) --- */
@media (max-width: 992px) {
  .contact-grid {
    grid-template-columns: 1fr; /* 1 kolom untuk tablet */
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 3rem 1rem 2rem 1rem;
  }
  .hero-title {
    font-size: 2.5rem;
  }
  .contact-grid,
  .location-section {
    padding: 0 1rem;
  }
}
</style>
